export const HidePassword = () => (
    <>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.058 3.736c-2.335-1.795-4.741-2.703-7.218-2.703-2.992 0-5.997 1.33-9.007 3.947l-.292.258-.208.188A32.93 32.93 0 0 0 .424 8.488L0 8.991l.367.546.113.167c1.493 2.186 3.148 3.891 4.959 5.107l1.484-1.124C5.283 12.7 3.77 11.262 2.38 9.366l-.187-.259.16-.181.215-.24a28.74 28.74 0 0 1 2.135-2.144l.28-.248.154-.132c2.655-2.268 5.221-3.383 7.703-3.383l.131.001.137.003c1.842.06 3.676.739 5.5 2.05l1.45-1.097Zm2.485 2.272-.148-.155a22.883 22.883 0 0 0-1.091-1.07l-1.417 1.074c.951.84 1.9 1.855 2.847 3.045l.164.208-.075.121-.101.159c-2.56 3.982-5.834 5.931-9.882 5.931h-.156l-.166-.004a11.246 11.246 0 0 1-4.016-.834L6.92 15.68c1.83.923 3.804 1.387 5.919 1.387 4.961 0 8.943-2.559 11.868-7.577L25 8.988l-.35-.463-.203-.267a30.353 30.353 0 0 0-1.638-1.963l-.266-.287Zm-4.702 3.2a5.001 5.001 0 0 1-7.826 4.128l1.514-1.147a3.255 3.255 0 0 0 4.534-3.435l1.516-1.148c.17.503.262 1.042.262 1.603Zm-1.017-3.022a5 5 0 0 0-7.973 6.04l1.392-1.055a3.255 3.255 0 0 1 5.189-3.93l1.392-1.055Z"
            fill="#4FAEBC"
        />
        <path
            d="m22.36 0 .959 1.265L1.097 18.1l-.959-1.265L22.36 0Z"
            fill="#4FAEBC"
        />
    </>
);

HidePassword.viewBox = '0 0 25 19';
